import { IonContent, IonPage, IonCol, IonRow, IonRadioGroup, IonLabel, IonItem, IonRadio, IonGrid, IonCard, IonCardTitle, IonDatetime, IonCardHeader, IonFooter, IonButton, IonIcon, IonInput, IonToast, IonSelectOption, IonSelect, IonPopover, IonList, useIonViewDidEnter } from '@ionic/react';
import React, { useContext, useEffect, useRef, useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import './ReadingSchedulerPage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import { trailSign, send, map, sync, timer, reader } from 'ionicons/icons';
import ReadingPlanRecordService from '../../services/ReadingPlanRecordService';
import IReadingPlanRecord from '../../interfaces/IReadingPlanRecord';
import { useDispatch, useSelector } from 'react-redux';
import { SelectActiveReadingPlanRecord, SelectActiveSession, SelectScheduledURL, UpdateActivePlanByIdAsync, SelectReadingPlans, UpdateActiveSession, UpdateLastViewedURL } from '../../store/BibleStudySlice';
import { SelectGroup, SelectGroupIds, SelectGroups, UpdateGroup } from '../../store/FellowshipSlice';
import { SelectCurrentUser, SelectLoginStatus } from '../../store/UserSlice';
import ServerDBContext from '../../components/ServerDBContext/ServerDBContext';
import { UserRouteInfo, UserRouteKeys } from '../../routes/UserRoutes';
import { useParams } from 'react-router';
import ReadingPlans, { AllReadingPlanCodes, ReadingPlanCodeValues, ReadingPlanCodes, createDefaultReadingPlanRecord } from '../../data/ReadingPlans';
import { ISessionsPerDayOptions } from '../../interfaces/IReadingPlan';

enum schedulerOptions {
  startDate,
  currentDay,
  groupCode,
}

const ReadingScheduler: React.FC<IRouteInfo> = (props:IRouteInfo) => {
  const dispatch = useDispatch();
  const { planCode, recordId, groupId } = useParams<{ planCode: string; recordId: string; groupId: string}>();
  const [schedulerType, setSchedulerType] = useState(schedulerOptions.startDate);
  const [startDate, setStartDate] = useState<string>(new Date().toISOString());
  const [selectedDay, setSelectedDay] = useState('0');
  const [readingPlanCode, setReadingPlanCode] = useState('');
  const [showDayPicker, setShowDayPicker] = useState(false);
  const [showDatePickerEvent, setShowDatePickerEvent] = useState<Event | undefined>(undefined);
  const [displayToastSuccess, setDisplayToastSuccess] = useState(false);
  const [displayToastFailed, setDisplayToastFailed] = useState(false);
  const [toastSuccessMessage, setToastSuccessMessage] = useState('Success: Updated Reading Plan.');
  const [toastFailedMessage, setToastFailedMessage] = useState('Failed: Unsuccess Updated Reading Plan.');
  const [resetCheckedDays, setResetCheckedDays] = useState<boolean>(false);
  const [showNavToScheduledButton, setShowNavToScheduledButton] = useState<boolean>(false);
  const [showResetCheckedDays, setShowResetCheckedDays] = useState<boolean>(false);
  const [sessionsPerDay, setSessionsPerDay] = useState(1);
  const activeSession = useSelector(SelectActiveSession);
  const userGroups = useSelector(SelectGroups);
  const userGroupIds = useSelector(SelectGroupIds);
  const currentGroup = useSelector(SelectGroup);
  const currentUser = useSelector(SelectCurrentUser);
  const LoggedIn = useSelector(SelectLoginStatus);
  const dbService = useContext(ServerDBContext);
  const scheduledSessionURL = useSelector(SelectScheduledURL);
  const schedulerPageContent = useRef<HTMLIonContentElement | null>(null);
  const userReadingPlans = useSelector(SelectReadingPlans);
  const ActiveReadingPlanRecord = useSelector(SelectActiveReadingPlanRecord);
  const [readingPlanName, setReadingPlanName] = useState('');
  const [editedReadingPlanRecord, setEditedReadingPlanRecord] = useState<IReadingPlanRecord | undefined>(undefined);
  const [planDescription, setPlanDescription] = useState('');
  const [paceOptions, setPaceOptions] = useState<ISessionsPerDayOptions[]>([]);
  const [activePlanCode, setActivePlanCode] = useState<ReadingPlanCodeValues>(ReadingPlanCodes.ccrbrp);
  const [activePlanGroupId, setActivePlanGroupId] = useState('');
  const [isGroupPlanAdmin, setIsGroupPlanAdmin] = useState(false);
  const [createNewPlan, setCreateNewPlan] = useState(false);

  useIonViewDidEnter(() => {
    setShowNavToScheduledButton(false);
    if(ActiveReadingPlanRecord && Number.isInteger(+recordId) && ActiveReadingPlanRecord.id === +recordId) {
      loadInitValues(ActiveReadingPlanRecord);
    } else {
      if(Number.isInteger(+recordId)) {
        ReadingPlanRecordService.getReadingPlanRecord(+recordId).then(planResponse =>  {
          if(planResponse.Success) {
            loadInitValues(planResponse.Data);
          }
        });
      } else {
        loadInitValues();
      }
    }
    setSelectedDay(activeSession ? activeSession?.session.toString() : '1');
  }, [ActiveReadingPlanRecord, activeSession, planCode, recordId, groupId]);

  const loadInitValues = (record?: IReadingPlanRecord) => {
    console.log('UPDATE RECORD:', record);
    let planGroupId = '';
    let readingPlanName: string | undefined = '';

    if(LoggedIn && userGroups && (record?.groupId || groupId)) {
      planGroupId = record?.groupId ? record?.groupId : groupId;
      planGroupId = Object.keys(userGroups).find(id => id === planGroupId) ? planGroupId : '';
      setActivePlanGroupId(planGroupId);
      const isAdmin = !!planGroupId && userGroups[planGroupId].group.creatorId === currentUser.id;
      setIsGroupPlanAdmin(isAdmin);
    } else {
      setActivePlanGroupId('');
      setIsGroupPlanAdmin(false);
    }

    if(record){
      setCreateNewPlan(false);
      setEditedReadingPlanRecord(record);
      setStartDate(record.startDate.toISOString()!);
      setReadingPlanCode(ReadingPlanRecordService.createPlanSyncCode!(record.startDate!, record.sessionsPerDay!, record.readingPlanCode));
      setShowResetCheckedDays(true);
      setSessionsPerDay(record.sessionsPerDay!);
      readingPlanName = record.name ? record.name : '';
      setReadingPlanName(readingPlanName);
      setPlanDescription(ReadingPlans[record.readingPlanCode].description);
      setPaceOptions(ReadingPlans[record.readingPlanCode].sessionsPerDayOptions);
      setActivePlanCode(record.readingPlanCode);
    } else {
      setCreateNewPlan(true);
      setStartDate(new Date().toISOString());
      setShowResetCheckedDays(false);
      const readingPlanCode = AllReadingPlanCodes.find(code => code === planCode) ? 
        planCode as ReadingPlanCodeValues : ReadingPlanCodes.ccrbrp;
      setPlanDescription(ReadingPlans[readingPlanCode ].description);
      setPaceOptions(ReadingPlans[readingPlanCode].sessionsPerDayOptions);
      setActivePlanCode(readingPlanCode);
      let newReadingPlanRecord = createDefaultReadingPlanRecord(readingPlanCode);
      readingPlanName = userGroups && planGroupId ? 
        userGroups[planGroupId].group.name : newReadingPlanRecord.name;
      newReadingPlanRecord.name = readingPlanName;
      setReadingPlanName(newReadingPlanRecord.name ? newReadingPlanRecord.name : '');
      newReadingPlanRecord.groupId = planGroupId;
      setEditedReadingPlanRecord(newReadingPlanRecord);
      console.log('NEW RECORD:', newReadingPlanRecord);
    }

    // Make sure name is not blank if its group reading plan because its not editable
    if(readingPlanName === '' && planGroupId) {
      setReadingPlanName('Unnamed Group Plan');
    }
  }

  useEffect(() => {
    if (Number.parseInt(selectedDay) > 730) {
      setSelectedDay('730');
    } else if (selectedDay !== '' && Number.parseInt(selectedDay) < 1) {
      console.log(selectedDay);
      setSelectedDay('1');
    }
  }, [selectedDay]);

  const updateCurrentDay = (sessionNumber: string) => {
    const currentMilliseconds = ((Number.parseInt(sessionNumber)-1)/sessionsPerDay) * 24 * 60 * 60 * 1000;
    const calculatedStartMilliseconds = Date.now() - currentMilliseconds;
    const calculatedStartDay = new Date(calculatedStartMilliseconds);
    storeStartDate(calculatedStartDay);
  }

  const loadGroupSyncCode = async (code: string) => {
    // code is plan_speed_dateInMilliseconds 'CCRBRP_1_1231923719231'
    const codeData = await ReadingPlanRecordService.interpretSyncCode!(code);
    if (codeData)
    {
      storeStartDate(codeData.startDate);
    }
  }

  const storeStartDate = (date: Date) => {
    console.log('storeStartDate', date, activePlanGroupId, isGroupPlanAdmin);
    if((activePlanGroupId && isGroupPlanAdmin) || !activePlanGroupId) {
      if(readingPlanName) {
        const record = editedReadingPlanRecord ?? createDefaultReadingPlanRecord(activePlanCode);
        record.name = readingPlanName;
        record.startDate = date;
        record.sessionsPerDay = sessionsPerDay;
        console.log('NEW/UPDATE RECORD:', record);
  
        // if the reading plan record exists already update it
        if(!createNewPlan) {
          if(resetCheckedDays) {
            record.completedSessions = [...createDefaultReadingPlanRecord(activePlanCode).completedSessions];
          }
          ReadingPlanRecordService.updateReadingPlanRecord(record).then(async result => {
            console.log('UPDATED NEW RECORD:', result.Data);
            if(result.Success) {
              // update reading plan record in redux
              UpdateActivePlanByIdAsync(dispatch, userGroupIds, record.id);
              setShowNavToScheduledButton(true);
              scrollToBottom();
  
              let success: boolean = result.Success;
              success = await setGroupSyncCode(date);
  
              if(success) {
                setReadingPlanCode(ReadingPlanRecordService.createPlanSyncCode!(result.Data?.startDate!, result.Data?.sessionsPerDay!, result.Data?.readingPlanCode!));
                setToastSuccessMessage(result.Message.UserMessage);
                setDisplayToastSuccess(true);
              } else {
                setDisplayToastFailed(true);
              }
            } else {
              setDisplayToastFailed(true);
            }
          });
        }
        else {

          // Check to make sure if there is a pre-existing group plan for this group that it would be converted to a personal plan
          if(record.groupId) {
            ReadingPlanRecordService.getReadingPlanRecords().then(records => {
              if(records.Success) {
                const groupPlanRecord = records?.Data?.filter(otherRecord => otherRecord.groupId === record.groupId);
                if(groupPlanRecord?.length) {
                  groupPlanRecord.forEach(planRecord => {
                    const name = `${planRecord.name} (OLD ${new Date(Date.now()).toLocaleDateString()})`;
                    const updateGroupPlan = {...planRecord, name, groupId: ''};  
                    ReadingPlanRecordService.updateReadingPlanRecord(updateGroupPlan);
                  });
                }
              }
            });
          }

          ReadingPlanRecordService.createReadingPlanRecord(record).then(async result => {
            console.log('CREATED NEW RECORD:', result.Data);
            if(result.Success) {
              setReadingPlanCode(ReadingPlanRecordService.createPlanSyncCode!(result.Data?.startDate!, result.Data?.sessionsPerDay!, result.Data?.readingPlanCode!));
              // update reading plan record in redux - NOTE: this will also set the active plan to the one just updated
              UpdateActivePlanByIdAsync(dispatch, userGroupIds, result.Data?.id);
              dispatch(UpdateLastViewedURL(''));
              dispatch(UpdateActiveSession(undefined));
              setShowNavToScheduledButton(true);
              scrollToBottom();
              setCreateNewPlan(false);

              let success: boolean = result.Success;
              success = await setGroupSyncCode(date);
  
              if(success) {
                setToastSuccessMessage(result.Message.UserMessage);
                setDisplayToastSuccess(true);
              } else {
                setDisplayToastFailed(true);
              }
            } else {
              setToastFailedMessage('Error: Failed to Update Reading Plan Schedule.');
              setDisplayToastFailed(true);
            }
          });
        }
      } else  {
        setToastFailedMessage('REQUIRED: Name Your Plan')
        setDisplayToastFailed(true);
      }
    } else {
      setToastFailedMessage('PLAN LOCKED: Group plans can only be edited by the group admin.')
      setDisplayToastFailed(true);
    }
  }

  const setGroupSyncCode = async (date: Date) => {
    let success = true;

    if(LoggedIn && isGroupPlanAdmin && userGroups && userGroups.hasOwnProperty(activePlanGroupId)) {
      const newGroupSyncCode = ReadingPlanRecordService.createPlanSyncCode!(date, sessionsPerDay, activePlanCode);
      const groupOfPlan = userGroups[activePlanGroupId].group;
      const response = await dbService?.updateGroup({...groupOfPlan, syncCode: newGroupSyncCode}, true);
      if(response?.Success) {
        dispatch(UpdateGroup({...groupOfPlan, syncCode: newGroupSyncCode}));
      }
      success = response ? response.Success : false;
    }

    return success;
  }

  // const pickerButtons = [
  //   {
  //     text: "Cancel",
  //     role: "cancel"
  //   },
  //   {
  //     text: "Confirm",
  //     handler: (value:any) => {
  //       setSelectedDay(value.Days.value);
  //       setShowDayPicker(false)
  //       console.log(value);
  //     }
  //   }
  // ];


  // const dayPickerOptions = () => {
  //   const daysArray = Array.from({length: 730}, (value, index) => {
  //     const dayNumber = index + 1;
  //     return { text: `Day ${dayNumber}`, value: dayNumber }
  //   });

  //   return {
  //     name: "Days",
  //     options: daysArray,
  //   };
  // };

  const getYearLimits = (option: string) => {
    const year = new Date(Date.now()).getFullYear();
    switch (option) {
      case 'min':
        return (year - 5).toString();
      case 'max':
        return (year + 1).toString() + "-12-31";
    }
  }
  
  const scrollToBottom = () => {
      const timerId = window.setInterval(()=> {
        schedulerPageContent.current && schedulerPageContent.current.scrollToBottom();
        window.clearInterval(timerId);
      }, 1000);
    };

  return (
    <IonPage>
        <PageHeader {...props} showBackButton={true} menuIcon={LoggedIn ? sync : undefined} navLink={LoggedIn ? UserRouteInfo[UserRouteKeys.SyncUserData].path : undefined} ></PageHeader>
        <IonContent color="light" ref={schedulerPageContent}>
          <IonGrid fixed={true}>
            <IonRow>
              <IonCol>
                <img className="reading-plan-banner" src={`${ReadingPlans[activePlanCode].sessionsURL}plan-banner.jpg`} />
                <h2 className="reading-plan-description-header"><IonIcon icon={trailSign} /> GETTING STARTED</h2>
                <p className="reading-plan-description">
                  {/* The Bible Study Together App currently use the Chronological Cross-Reference Bible Reading Plan. It is designed to start on a Saturday, but can be started on whatever day you want. It is a plan that takes you through <b>the entire Bible chronologically while regularly connecting NT and OT passages into the daily reading.</b> Each reading typically takes less than 10 minutes. Below you can set the pace going through the plan ranging from 2 years to 92 days. Also, you can set your start date three different ways: select the day you want to start your reading plan, choose a specific day of the plan that you want to be your current day's reading, or enter a code from a group member to synchronize with their reading schedule. */}
                  {planDescription}
                </p>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol>
                <h2 className="reading-plan-description-header"><IonIcon icon={reader} /> NAME YOUR PLAN</h2>
                <p className="reading-plan-description"><i>
                  { !!activePlanGroupId ? 
                    'Group reading plans are named after your group automatically to easily identify it throughout the app.' :
                    'Your plan name will help you identify this plan more easily throughout the app.' 
                  }
                </i></p>
                <IonInput 
                  aria-label="TITLE" 
                  placeholder="Example: My Personal Plan"
                  fill="outline" 
                  className="reading-schedule-reset-checks" 
                  value={readingPlanName} 
                  onIonChange={e => setReadingPlanName(e.detail.value!.toString())}
                  required={true}
                  disabled={!!activePlanGroupId}/>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol>
                <h2 className="reading-plan-description-header"><IonIcon icon={timer} /> SET READING PLAN PACE</h2>
                <IonSelect
                  className="reading-schedule-reset-checks"
                  fill="outline"
                  mode="md"
                  interface="popover"
                  value={sessionsPerDay}
                  onIonChange={(e) => setSessionsPerDay(e.detail.value)}
                >
                  { paceOptions.map(option => 
                    <IonSelectOption key={`${option.value}-desc`} value={option.value}>{option.description}</IonSelectOption>
                  )}
                </IonSelect>
              </IonCol>
            </IonRow>
            <IonRow >
              <IonCol>
                <h2 className="reading-plan-description-header"><IonIcon icon={map} /> SCHEDULE SETUP METHOD</h2>
                <IonRadioGroup name="method" className="scheduler-method-radio-group" color="light" value={schedulerType} onIonChange={e => setSchedulerType(e.detail.value)}>
                  <IonList color={'light'} mode="md">
                    <IonItem lines='none' color={'light'}>
                      <IonRadio name="method" justify="start" labelPlacement="start" color="primary" value={schedulerOptions.startDate}>SELECT START DATE</IonRadio>
                    </IonItem>
                    <IonItem lines='none' color={'light'}>
                      <IonRadio name="method" justify="start" labelPlacement="start" color="primary" value={schedulerOptions.currentDay}>SET CURRENT DAY</IonRadio>
                    </IonItem>
                    <IonItem lines='none' color={'light'}>
                      <IonRadio name="method" justify="start" labelPlacement="start" color="primary" value={schedulerOptions.groupCode}>ENTER GROUP SYNC CODE</IonRadio>
                    </IonItem>
                  </IonList>
                </IonRadioGroup>
                { showResetCheckedDays && <IonSelect
                    className="reading-schedule-reset-checks"
                    fill="outline"
                    mode="md"
                    interface="popover"
                    value={resetCheckedDays}
                    onIonChange={(e) => setResetCheckedDays(e.detail.value)}
                  >
                    <IonSelectOption value={false}>Keep checked read days</IonSelectOption>
                    <IonSelectOption value={true}>Reset checked read days</IonSelectOption>
                  </IonSelect>
                  }
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol>
                  {
                    schedulerType === schedulerOptions.startDate ?
                    <IonCard color="primary" mode="md">
                      <IonCardHeader className="scheduler-card-header">
                        <IonCardTitle className="scheduler-card-title">Reading Plan Scheduler</IonCardTitle>
                      </IonCardHeader>
                      <IonItem className="scheduler-item">
                        <IonLabel color="primary">SELECT START DATE:</IonLabel>
                        <IonButton slot="end" onClick={e => {
                            setShowDayPicker(true);
                            setShowDatePickerEvent(e.nativeEvent);
                          }}>{new Date(startDate).toLocaleDateString()}</IonButton>
                        <IonPopover className="scheduler-date-picker"
                          isOpen={showDayPicker}
                          event={showDatePickerEvent}
                          onDidDismiss={() => {
                            setShowDayPicker(false);
                            setShowDatePickerEvent(undefined);
                          }} alignment="center" side="top" mode="md">
                          <IonContent>
                            <IonDatetime className="scheduler-input-box" color="primary" 
                              value={startDate} onIonChange={e => {
                                setStartDate(e.detail.value?.toString()! as string);
                                setShowDayPicker(false);
                              }} 
                              min={getYearLimits('min')}  max={getYearLimits('max')}
                              presentation='date'
                              mode="md"
                              multiple={false}
                              >
                              </IonDatetime>
                          </IonContent>
                        </IonPopover>
                      </IonItem>
                      <IonFooter className="scheduler-footer">
                        <IonButton className="scheduler-submit-button" onClick={() => storeStartDate(new Date(startDate))}>
                          SET START DATE
                          <IonIcon icon={send} />
                        </IonButton>
                      </IonFooter>
                    </IonCard> :
                    schedulerType === schedulerOptions.currentDay ?
                      <IonCard color="primary" mode="md">
                        <IonCardHeader className="scheduler-card-header">
                          <IonCardTitle className="scheduler-card-title">Reading Plan Scheduler</IonCardTitle>
                        </IonCardHeader>
                        <IonItem className="scheduler-item">
                          <IonLabel color="primary">SELECT CURRENT DAY:</IonLabel>
                          <IonInput label="SELECT CURRENT DAY:" labelPlacement="start" color="primary" 
                            type="number" className="scheduler-input-box" value={selectedDay} 
                            onIonChange={e => setSelectedDay(e.detail.value?.toString()!)}></IonInput>
                        </IonItem>
                        <IonFooter className="scheduler-footer">
                          <IonButton className="scheduler-submit-button" onClick={() => updateCurrentDay(selectedDay)}>
                            SET CURRENT DAY
                            <IonIcon icon={send} />
                          </IonButton>
                        </IonFooter>
                      </IonCard> :
                      <IonCard color="primary" mode="md">
                        <IonCardHeader className="scheduler-card-header">
                          <IonCardTitle className="scheduler-card-title">Reading Plan Scheduler</IonCardTitle>
                        </IonCardHeader>
                        <IonItem className="scheduler-item">
                          <IonInput placeholder="SYNC-GROUP-CODE"
                            className="scheduler-input-box"
                            color="primary"
                            value={readingPlanCode}
                            label='ENTER SYNC CODE:'
                            onIonChange={e => setReadingPlanCode(e.detail.value?.toString()!)}
                            onFocus={e => e.currentTarget.getInputElement().then(text => text.select())}>
                          </IonInput>
                        </IonItem>
                        <IonFooter className="scheduler-footer">
                          <IonButton className="scheduler-submit-button" onClick={() => loadGroupSyncCode(readingPlanCode)}>
                            RESET CURRENT DAY WITH CODE
                            <IonIcon icon={send} />
                          </IonButton>
                        </IonFooter>
                      </IonCard>
                  }
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol>
                  {showNavToScheduledButton && <IonButton className="start-plan-button" expand='full' routerLink={scheduledSessionURL}>START YOUR PLAN</IonButton> }
                </IonCol>
              </IonRow>
            </IonGrid>
            <IonToast color="success"
              isOpen={displayToastSuccess}
              onDidDismiss={() => setDisplayToastSuccess(false)}
              message={toastSuccessMessage}
              duration={1000} />
            <IonToast color="danger"
              isOpen={displayToastFailed}
              onDidDismiss={() => setDisplayToastFailed(false)}
              message={toastFailedMessage}
              duration={3000} />
        </IonContent>
        <IonFooter>
          <div className="reading-scheduler-ios-safe-zone"></div>
        </IonFooter>
    </IonPage>
  );
};

export default ReadingScheduler;
